<template>
  <transition name="modal">
    <div class="modal-wrapper">
      <div
        class="modal-mask"
        @click="$emit('closeModal')"
      >
      </div>

      <div
        class="modal-container"
        :class="classes"
      >
        <button
          id="close-button"
          class="close-button"
          @click="$emit('closeModal')"
        >
          &times;
        </button>
        <div class="modal-body">
          <header class="p-2">
            <slot
              name="modal-title"
            ></slot>
          </header>
          <slot>
          </slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    classes: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-wrapper {
  display: flex;
  vertical-align: middle;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;

  .modal-mask {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    position: absolute;
    transition: opacity .3s ease;
  }

  .modal-container {
    width: 90%;
    max-width: 500px;
    max-height: 90%;
    margin: 0 auto;
    background-color: get-color('clear');
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    position: relative;
    z-index: 2;
    overscroll-behavior-y: auto;
    margin: auto;
  }

  .modal-body {
    color: black;
    margin: 10px 0;
    width: 100%;
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  .close-button {
    background: transparent;
    border: 0;
    text-decoration: none;
    cursor: pointer;
    position: absolute;
    font-size: 2rem;
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
    top: 1rem;
    right: 1rem;
    line-height: 1rem;
    padding: 0;
  }
}
</style>

<style lang="scss">
.modal-wrapper {
  .button {
    font-size: 15px;
  }
}
</style>
